import { FETCH_CATEGORY_GAME_COUNT_SUCCESS } from "./actionTypes";


const temp = {
    "live-casino": {
        "game_count": 0,
    },
    "arcades": {
        "game_count": 0,
    },
    "card-games": {
        "game_count": 0,
    },
    "slots": {
        "game_count": 0,
    },
    "sportsbook": {
        "game_count": 0,
    },
    "fishing": {
        "game_count": 0,
    },
    "dingdong": {
        "game_count": 0,
    },
    "lottery": {
        "game_count": 0,
    },
    "crash-game": {
        "game_count": 0,
    }
};

const initialState = {
    data: temp,
};


const categoryGameCountR = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CATEGORY_GAME_COUNT_SUCCESS:
            console.log("Fetching media info from API. If delayed, default images will be used.");
            const updatedData = action.payload.response || temp ;
            if (!action.payload.response) {
                console.log("API response delayed or unavailable. Loading default images.");
            }
            return { ...state, data: updatedData };
        default:
            return state;
    }
};

export default categoryGameCountR;